import { Timestamp } from 'firebase/firestore';

export enum SignatureEnvelopeStatus {
  DRAFT = 'DRAFT',
  SENT = 'SENT',
  CLIENT_SIGNED = 'CLIENT_SIGNED',
  COMPANY_SIGNED = 'COMPANY_SIGNED',
  COMPLETED = 'COMPLETED'
}

export enum SignatureSourceType {
  PDF_UPLOAD = 'pdf_upload',
  DOCUMENT_TEMPLATE = 'document_template'
}

export enum SignatureType {
  DRAW = 'draw',
  TYPE = 'type'
}

export interface ClientSigner {
  name: string;
  email: string;
  signedAt?: Timestamp;
  signingDate?: Date;
  signatureType?: SignatureType;
  signatureImageUrl?: string;
  typedName?: string;
  ipAddress?: string;
  userAgent?: string;
  otpVerified?: boolean;
}

export interface CompanySigner {
  userId: string;
  name: string;
  email: string;
  signedAt?: Timestamp;
  signingDate?: Date;
  signatureType?: SignatureType;
  signatureImageUrl?: string;
  typedName?: string;
}

export interface AuditLogEntry {
  action: string;
  actor: string;
  actorRole: 'client' | 'company';
  timestamp: Timestamp;
  ipAddress?: string;
  userAgent?: string;
  metadata?: Record<string, any>;
}

export interface SignatureEnvelope {
  envelopeId: string;
  documentId?: string;
  organizationId: string;
  clientId: string;
  clientSigner: ClientSigner;
  companySigner: CompanySigner;
  signingOrder: 'client' | 'company';
  status: SignatureEnvelopeStatus;
  sourceType: SignatureSourceType;
  originalPdfUrl: string;
  originalPdfSha256: string;
  finalPdfUrl?: string;
  finalPdfSha256?: string;
  clientToken?: string;
  tokenUsed?: boolean;
  tokenExpiresAt?: Timestamp;
  auditLog: AuditLogEntry[];
  locked: boolean;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

export interface SigningToken {
  token: string;
  envelopeId: string;
  signerRole: 'client';
  signerEmail: string;
  used: boolean;
  expiresAt: Timestamp;
  createdAt: Timestamp;
}

export interface OTPCode {
  code: string;
  envelopeId: string;
  email: string;
  verified: boolean;
  expiresAt: Timestamp;
  createdAt: Timestamp;
}
